import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/State.vue'
import About from '../views/Dataupload.vue'
import Login from '../views/Login.vue'
import UserManagement from '../views/UserManagement.vue'
import SessionStore from '../stores/AuthStore'
import sessionStore from "../stores/AuthStore";
import API from '@/views/API.vue'
import Imprint from "@/views/Imprint";
import ProductStore from "@/stores/ProductStore";

Vue.use(VueRouter)
// TODO rename file to index.ts and change the below definition to const routes: Array<RouteConfig> = [ ..
  const routes = [

  {
    path: '/datenupload',
    name: 'Datenupload',
    component: About
  },
  {
    path: '/',
    name: 'Endpunkte',
    component: Home
  },
  {
    path: '/nutzerverwaltung',
    name: 'Nutzerverwaltung',
    component: UserManagement
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout'
  },
  {
    path: '/api',
    name: 'API-Dokumenation',
    component: API
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Imprint
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const publicRoutes = ['Login']
  if(to.name === 'Logout'){
    SessionStore.commit('logout')
    ProductStore.setProduct(null)
  }
  if (!publicRoutes.includes(to.name) && !sessionStore.state.isLoggedIn()) {
    next('/login')
  } else if(publicRoutes.includes(to.name) && sessionStore.state.isLoggedIn()) {
    next('/')
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  window.document.title = `LTS | ${to.name}`
})

export default router
